import React, { useState, useEffect } from 'react';
import LogoForm from './LogoForm'
import { withStyles, Paper, Dialog, CircularProgress } from '@material-ui/core';
import config from '../../../config/config';
import { parseURL } from "../../sc-utilities";
import * as Yup from "yup";
import * as actions from './store/logoActions';
import History from "../../../History";
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const LogoEdit = props => {
    const { classes, logo, activeCustomer, translations, onFetchLogoInit, permissions, onFetchLogo, onEditLogo } = props;
    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '', imageValue: null, data: true, valid: true });

    const handleUpload = event => {
        let file = event[0];
        if (!file) {
            let relativePath = logo?.ImageLocation?.split('/') ?? [];
            relativePath.shift();
            setFileToSend({ ...fileToSend, imageValue: logo?.ImageLocation ? `${config.backend_static}/${relativePath.join('/')}` : '' });
            return
        }
        setFileToSend({ ...fileToSend, fileToSend: file, fileName: file.name, imageValue: URL.createObjectURL(file), valid: false });
    };

    useEffect(() => {
        const fetchData = async () => {
            await onFetchLogo({ LogoID: parseURL(window.location.href).logoID, ActiveCustomerID: activeCustomer });
        }
        fetchData();

        return () => {
            onFetchLogoInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (logo) {
            let relativePath = logo.ImageLocation?.split('/') ?? [];
            relativePath.shift();
            setFileToSend({ ...fileToSend, data: false, imageValue: logo.ImageLocation ? `${config.backend_domain}:${config.backend_port}/static/${relativePath.join('/')}` : '' });
        }
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logo]);

    const handleSubmit = async dataForm => {
        const data = new FormData();
        data.append("Image", logo.Image);
        data.append("LogoID", logo.LogoID);
        data.append("File", fileToSend.fileToSend);
        data.append("FileName", fileToSend.fileName);
        data.append("Name", dataForm.Name);
        data.append("ActiveCustomerID", activeCustomer);

        let token = localStorage.getItem("SESSION");

        data.append("Token", token);

        let result = await onEditLogo(data);
        if (result) {
            History.goBack();
        }
        if (!result) {
            let relativePath = logo?.ImageLocation?.split('/') ?? [];
            relativePath.shift();
            setFileToSend({ fileToSend: {}, fileName: '', data: true, imageValue: logo?.ImageLocation ? `${config.backend_domain}:${config.backend_port}/static/${relativePath.join('/')}` : '', valid: true });
        }
    }

    let initialValues = {
        Name: logo && logo.Name ? logo.Name : ""
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
        },
        FormTitle: translations["edit_logo"] || "Edit logo",
        ButtonSubmit: hasPermission(permissions, "logo_save") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null,
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={fileToSend.data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            {!fileToSend.data ?
                <LogoForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    edit={true}
                    loading={fileToSend.valid}
                    handleUpload={handleUpload}
                    translations={translations}
                    imageValue={fileToSend.imageValue}
                />
                : <CircularProgress
                    variant="static"
                    color="primary"
                    size={28}
                />}
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        logo: state.setting.logos.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchLogoInit: Logo => dispatch(actions.cleanState(Logo)),
        onFetchLogo: logo => dispatch(actions.loadLogo(logo)),
        onEditLogo: logo => dispatch(actions.editLogo(logo))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(LogoEdit));